module.exports = __webpack_public_path__ + "img/zappos_logo.15bba9ab.png";